import { useMemo } from 'react';

export const useOrderCarrierPricing = (orders, backupText = 'We will contact you') => {
    return useMemo(() => {
        const ordersArray = Array.isArray(orders) ? orders : [orders];

        if (ordersArray.every((order) => !!order?.carrier_rate)) {
            return `$${ordersArray.reduce((total, order) => total + order.carrier_rate, 0)?.toFixed(2)}`;
        }
        return backupText;
    }, [orders, backupText]);
};
